import React, { useMemo } from 'react';
import { GeoJSON } from 'react-leaflet';
import type { PathOptions } from 'leaflet';
import type { FeatureCollection } from 'geojson';
import waterMaskData from '../../data/water-mask.json';

/**
 * Overlays major inland water bodies (Great Lakes, Great Salt, Lake
 * Okeechobee, etc.) with an opaque dark fill. Used on top of thematic
 * basemaps (AGB 100m) where the upstream raster has no reliable water
 * mask — without this, freshwater lakes render with misclassified
 * biomass colors and read as patchy forest.
 *
 * Ocean is already rendered dark by the basemap itself, so we only need
 * to mask inland bodies. Black matches the AGB void color at all
 * visible zooms; any seam along lake/ocean shorelines is invisible.
 */
const STYLE: PathOptions = {
  stroke: false,
  fill: true,
  fillColor: '#000000',
  fillOpacity: 1,
  interactive: false,
};

const data = waterMaskData as unknown as FeatureCollection;

export const WaterMask: React.FC = () => {
  // Memoize the key to avoid react-leaflet re-creating the layer on every
  // render. Data is static so the identity is stable.
  const key = useMemo(() => 'water-mask', []);
  return <GeoJSON key={key} data={data} style={STYLE} />;
};
